<template>
  <div
    v-if="visible"
    class="estudyoo-loading-banner mb-3 p-3 border-round border-1 surface-border flex align-items-center gap-2"
    role="status"
    aria-live="polite"
  >
    <i class="pi pi-spin pi-spinner text-primary" aria-hidden="true" />
    <span class="text-sm text-600">{{ message }}</span>
  </div>
</template>

<script setup>
defineProps({
  visible: { type: Boolean, default: false },
  message: { type: String, default: 'Procesando…' },
});
</script>
